<template>
  <router-view />
</template>

<script>
export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'CheckoutLayout'
};
</script>
